import { Button, Dialog, Text, VSpacer } from '@/components/DesignSystem';
import { ApiUser } from '@api/interfaces';
import { Divider } from '@mui/material';
import { getAccountName } from '@shared/utilities';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface SalespeopleDialogProps {
  accountGroupId?: string,
  customer: ApiUser,
  onClose: () => void,
  salespeople: ApiUser[],
}

export const SalespeopleDialog = ({
  accountGroupId,
  customer,
  onClose,
  salespeople,
}: SalespeopleDialogProps) => {
  const sortedSalespeople = salespeople.sort(
    (a, b) => getAccountName(a).localeCompare(getAccountName(b)),
  );
  const { t } = useTranslation();
  const subtitle = accountGroupId
    ? t($ => $.overview.salespeopleDialog.accountGroupSubtitle, { accountGroupId })
    : t($ => $.overview.salespeopleDialog.subtitle, { customerName: getAccountName(customer) });
  return (
    <Dialog
      acceptButton={(props) => (
        <Button
          {...props}
          onClick={onClose}
          testID="close-salespeople-dialog-button"
          variant="contained"
        >
          {t($ => $.common.actions.close)}
        </Button>
      )}
      onClose={onClose}
      open
      showCloseButton={false}
      subtitle={subtitle}
      testID="salespeople-dialog"
      title={t($ => $.overview.salespeopleDialog.title)}
    >
      {sortedSalespeople.map((salesperson) => (
        <Fragment key={salesperson.id}>
          <VSpacer size="4" />
          <Text category="label-large">
            {getAccountName(salesperson)}
          </Text>
          <VSpacer size="2" />
          <Text category="body-small">
            {t($ => $.common.id, { id: salesperson.externalId })}
          </Text>
          <VSpacer size="4" />
          <Divider />
        </Fragment>
      ))}
    </Dialog>
  );
};
